import React, { useState, useEffect, useRef } from 'react';
import '../Header/Header.css';
import MobileHeader from '../MobileHeader/MobileHeader';
import IBSlogo from '../../Assets/Images/ibs_white.png';
import IBSlogo1 from '../../Assets/Images/ibslogo.png';
import { Link } from 'react-router-dom';
import whatsapp from '../../Assets/Images/whatsapp.png';
import phncall from '../../Assets/Images/phone-call.png';
// import Lines from '../../Components/Lines/Lines'
import aiicon from '../../Assets/Images/aiicon.png'
import mobile from '../../Assets/Images/mob-169x300.png'
import web from '../../Assets/Images/web-300x240.png'
import screen from '../../Assets/Images/Mobile_Screen.png'
import invoicemint from '../../Assets/Images/Invoicemint.png'
import seo from '../../Assets/Images/Group-2174.png'
import blogger from '../../Assets/Images/Group-2175.png'
import native1 from '../../Assets/Images/Group-828.png'
import native2 from '../../Assets/Images/Group-829.png'
import native3 from '../../Assets/Images/Group-829.png'
import native4 from '../../Assets/Images/Group-830.png'
import cpa1 from '../../Assets/Images/Group-832.png'
import cpa2 from '../../Assets/Images/Group-833.png'
import cpa3 from '../../Assets/Images/Group-834.png'
import gaming1 from '../../Assets/Images/Unity-Engine.png'
import gaming3 from '../../Assets/Images/AR_VR.png'
import gaming2 from '../../Assets/Images/2D-Games_3D-Games.png'
import webapp1 from '../../Assets/Images/Group-835.png'
import webapp2 from '../../Assets/Images/Group-836.png'
import webapp3 from '../../Assets/Images/Group-837.png'
import webdevelopement1 from '../../Assets/Images/Group-838.png'
import webdevelopement2 from '../../Assets/Images/Group-839.png'
import webdevelopement3 from '../../Assets/Images/Group-841.png'
import webdevelopement4 from '../../Assets/Images/Group-842.png'
import designing1 from '../../Assets/Images/Group-847.png'
import designing2 from '../../Assets/Images/Group-848.png'
import designing3 from '../../Assets/Images/Group-851.png'
import blockchain1 from '../../Assets/Images/Group-828-1.png'
import blockchain2 from '../../Assets/Images/Group-829-1.png'
import blockchain3 from '../../Assets/Images/Group-831-1.png'
import spliimg from '../../Assets/Images/spliimg.png'
import { useLocation } from 'react-router-dom';
import animaa from '../../Assets/Images/animation/Group0.png'
import animab from '../../Assets/Images/animation/Group1.png'
import animac from '../../Assets/Images/animation/Group2.png'
import animad from '../../Assets/Images/animation/Group3.png'
import animae from '../../Assets/Images/animation/Group4.png'
import animaf from '../../Assets/Images/animation/Group5.png'
import animag from '../../Assets/Images/animation/Group6.png'
import animah from '../../Assets/Images/animation/Group7.png'
import Appdevelopment from '../../Assets/Images/animation/App-development.gif'
import Mobiledevelopment from '../../Assets/Images/animation/Mobile-development.gif'
import Gameanalytics from '../../Assets/Images/animation/Game-analytics.gif'
import Mobilebrowsers from '../../Assets/Images/animation/Mobile-browsers.gif'
import Websitedesigner from '../../Assets/Images/animation/Website-designer.gif'
import Graphicdesign from '../../Assets/Images/animation/Designer-girl.gif'
import BitcoinP2P from '../../Assets/Images/animation/Bitcoin-P2P.gif'
import linkdemo from '../../Assets/Images/og-image.png'


const Header = () => {

  // const svgRef = useRef(null);
  // const circlesGroupRef = useRef(null);

  // useEffect(() => {
  //   const loopingPath = svgRef.current.querySelector('#loopingPath');
  //   const circlesGroup = circlesGroupRef.current;
  //   const pathLength = loopingPath.getTotalLength();

  //   // Configuration variables
  //   const circleSize = 3;
  //   const firstColor = 'rgba(255, 255, 255, 1)';
  //   const middleColor = 'rgba(80, 100, 255, 1)';
  //   const lastColor = 'rgba(71, 223, 168, 1)';
  //   const moveSpeed = 8;
  //   const wormLengthPercent = 95;
  //   const numCircles = 90;






  //   setTimeout(() => {
  //     const loader = document.querySelector('.loading-spinner');
  //     const content = document.querySelector('.contentibs');

  //     if (loader) loader.style.display = 'none';
  //     if (content) content.style.display = 'block';
  //   }, 3000);





  //   // Pre-calculate the distance between circles along the path
  //   const step = (wormLengthPercent / 100 * pathLength) / numCircles;

  //   // Pre-parse color values once to avoid repeated regex calls
  //   const parseColor = (color) => color.match(/\d+\.?\d*/g).map(Number);
  //   const parsedFirst = parseColor(firstColor);
  //   const parsedMiddle = parseColor(middleColor);
  //   const parsedLast = parseColor(lastColor);

  //   // Interpolate between two parsed RGBA colors using a factor (0 to 1)
  //   function interpolateParsedColor(c1, c2, factor) {
  //     const r = Math.round(c1[0] + factor * (c2[0] - c1[0]));
  //     const g = Math.round(c1[1] + factor * (c2[1] - c1[1]));
  //     const b = Math.round(c1[2] + factor * (c2[2] - c1[2]));
  //     const a = c1[3] + factor * (c2[3] - c1[3]);
  //     return `rgba(${r}, ${g}, ${b}, ${a})`;
  //   }

  //   // Create circles and set their initial attributes
  //   const circles = Array.from({ length: numCircles }, () => {
  //     const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  //     circle.setAttribute('r', circleSize);
  //     circlesGroup.appendChild(circle);
  //     return circle;
  //   });

  //   let offset = 0;
  //   // Pre-calculate the speed factor for smoother animation
  //   const speedFactor = (moveSpeed / pathLength) * 10;

  //   function updateCircles() {
  //     for (let i = 0; i < numCircles; i++) {
  //       const position = i * step;
  //       const point = loopingPath.getPointAtLength((position + offset) % pathLength);
  //       const t = i / (numCircles - 1);
  //       // Determine the color based on the relative position
  //       let color = t < 0.5
  //         ? interpolateParsedColor(parsedFirst, parsedMiddle, t * 2)
  //         : interpolateParsedColor(parsedMiddle, parsedLast, (t - 0.5) * 2);

  //       circles[i].setAttribute('cx', point.x);
  //       circles[i].setAttribute('cy', point.y);
  //       circles[i].setAttribute('fill', color);
  //     }
  //     offset = (offset + speedFactor) % pathLength;
  //     requestAnimationFrame(updateCircles);
  //   }

  //   requestAnimationFrame(updateCircles);
  // }, []);


  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeMegaMenu, setActiveMegaMenu] = useState(null);
  const [submenuTimeout, setSubmenuTimeout] = useState(null);
  const [activeSection, setActiveSection] = useState('blockchain-development');
  const [isButtonScroll, setIsButtonScroll] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [activeLink, setActiveLink] = useState('');
  const location = useLocation(); // Access current route
  const linkRefs = useRef({});

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  useEffect(() => {
    setIsMenuOpen(false);
    setActiveMegaMenu(null);
  }, [location]);

  // Scroll event for header with route-specific logic
  useEffect(() => {
    const isOnAIPage = location.pathname === '/developing-with-ai';

    if (isOnAIPage) {
      // Ensure header stays in "before-scroll" state
      setIsScrolled(false);
      setIsButtonScroll(false);
      return; // Skip attaching the scroll listener
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY; // Get current scroll position
      const triggerHeight = window.innerHeight; // 100vh in pixels

      setIsScrolled(scrollPosition >= triggerHeight); // Check if scrolled down at all
      setIsButtonScroll(scrollPosition >= triggerHeight); // Trigger event at 100vh or beyond
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]); // Re-run when the route changes

  const toggleMegaMenu = (menu) => {
    setActiveMegaMenu(activeMegaMenu === menu ? null : menu);
  };

  const handleMouseEnter = (menu) => {
    if (submenuTimeout) {
      clearTimeout(submenuTimeout);
    }
    setActiveMegaMenu(menu);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setActiveMegaMenu(null);
    }, 300);
    setSubmenuTimeout(timeout);
  };

  const handleClick = (menu, linkId) => {
    setActiveMenu(menu);

    // Remove hover effect from all links first
    const allLinks = document.querySelectorAll(".native-apps");
    allLinks.forEach(link => link.classList.remove("hover-effect"));

    // Add hover effect only to the clicked link
    if (linkRefs.current[linkId]) {
      linkRefs.current[linkId].classList.add("hover-effect");
    }
  };


  const isActivePath = (path) => location.pathname.startsWith(path);


  const handleMenuClose = () => {
    setActiveMegaMenu(null);
    setIsMenuOpen(false);
  };

  // blockchain
  const blockchainPaths = [
    '/services/blockchain-development',
    '/services/ALT-coin-development',
    '/services/multichain-blockchain-development',
    '/services/crypto-mlm-software-development',
    '/services/smart-contract-development',
    '/services/crypto-wallet-development',
    '/services/crypto-currency-exchange-development',
    '/Crypto-Token-Development',
    '/ERCToken',
    '/EthereumTokenDevelopment',
    '/solana-token',
    '/tron-token',
    '/white-paper',
    '/polygon-development',
  ];

  const isBlockchainActive = blockchainPaths.some(path => location.pathname === path);


  // animation
  const animationPaths = [
    '/animation',
  ];

  const isAnimationActive = animationPaths.some(path => location.pathname === path);

  // cross platform
  const crossplatformPaths = [
    '/services/native-apps/Mobile-development',
  ];

  const isCrossplatformActive = crossplatformPaths.some(path => location.pathname === path);



  // gaming
  const gamingPaths = [
    '/services/unity-gaming',
  ];

  const isGamingActive = gamingPaths.some(path => location.pathname === path);

  // web apps
  const webappsPaths = [
    '/services/website',
  ];

  const isWebappsActive = webappsPaths.some(path => location.pathname === path);




  // website development
  const websitePaths = [
    '/services/website',
  ];

  const isWebsiteActive = websitePaths.some(path => location.pathname === path);



  // designing
  const designingPaths = [
    '/services/designing',
  ];

  const isDesigningActive = designingPaths.some(path => location.pathname === path);


  // mobile portfolio
  const mobileportfolioPaths = [
    '/Mobile-Portfolio',
  ];

  const isMobileAppsActive = mobileportfolioPaths.some(path => location.pathname === path);




  // website portfolio
  const webportfolioPaths = [
    '/web-portfolio',
  ];

  const isWebsiteportfolioActive = webportfolioPaths.some(path => location.pathname === path);



  // gaming portfolio
  const gameportfolioPaths = [
    '/game-portfolio',
  ];

  const isGamingportfolioActive = gameportfolioPaths.some(path => location.pathname === path);



  // our product portfolio
  const ourproductsPaths = [

  ];

  const isOurproductsActive = ourproductsPaths.some(path => location.pathname === path);

  // portfolio 
  const isPortfolioActive = ['/portfolio', '/Mobile-Portfolio', '/web-portfolio', '/game-portfolio'].includes(location.pathname);





  return (
    <div className="container">
      <img className='linimg' src={linkdemo} alt="" />
      <div className="row">
        <div className="col-md-12">
          <header className={`header-com ${isScrolled ? 'scrolled' : ''}`} id="header-com">
            <div className="logo">
              <Link
                to="/"
                onClick={() => {
                  setTimeout(() => {
                    window.location.reload();
                  }, 0);
                }}
              >
                <img
                  src={IBSlogo}
                  alt="Logo"
                  className={`logo-white ${isScrolled ? 'scrolled' : ''}`}
                />
              </Link>

              <Link
                to="/"
                onClick={() => {
                  setTimeout(() => {
                    window.location.reload();
                  }, 0);
                }}
              >
                <img
                  src={IBSlogo1}
                  alt="Logo"
                  className={`logo-color ${isScrolled ? 'scrolled' : ''}`}
                />
              </Link>

              <div
                // className="logoimgtex"
                className={`logoimgtex ${isButtonScroll ? 'show' : ''}`}>            <a href="/developing-with-ai" id="line-removal"><span>Developing Faster With AI <img src={aiicon} alt="" /></span></a>
              </div>
            </div>
            <nav className={`navbar ${isNavOpen ? 'show' : ''}`}>
              <ul id="nav-list" className="navbar-links">
                <li onClick={() => toggleMegaMenu('about')}>
                  <Link
                    to="/about"
                    onClick={() => {
                      setTimeout(() => {
                        window.location.reload();
                      }, 0);
                    }}
                    className={location.pathname === '/about' ? 'active-link' : ''}
                  >
                    About Us
                  </Link>

                </li>
                <li
                  onMouseEnter={() => handleMouseEnter('marketing')}
                  onMouseLeave={handleMouseLeave}                 >

                  <Link
                    to="#"
                    onClick={() => handleLinkClick('marketing')}
                    className={
                      location.pathname.startsWith('/marketing') || activeLink === 'marketing'
                        ? 'active-link'
                        : ''
                    }
                  >
                    Marketing
                  </Link>
                  {activeMegaMenu === 'marketing' && (
                    <div className="mega-menu" id="marketing">
                      <ul>
                        <li> <Link
                          to="/marketing/seo"
                          onClick={() => {
                            setTimeout(() => {
                              window.location.reload();
                            }, 0);
                          }}
                          className={location.pathname === '/marketing/seo' ? 'active-link' : ''}
                        >
                          <img src={seo} alt="" />&nbsp;&nbsp;SEO
                        </Link>
                        </li>
                        <li> <Link
                          to="/marketing/blogger-outreach"
                          onClick={() => {
                            setTimeout(() => {
                              window.location.reload();
                            }, 0);
                          }}
                          className={location.pathname === '/marketing/blogger-outreach' ? 'active-link' : ''}
                        >
                          <img src={blogger} alt="" />&nbsp;&nbsp;Blogger Outreach Services
                        </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </li>
                <li
                  onMouseEnter={() => handleMouseEnter('portfolio')}
                  onMouseLeave={handleMouseLeave}                >
                  {/* <Link to='/portfolio'
                    onClick={() => { handleLinkClick('portfolio'); }}
                    className={isActivePath('/portfolio') ? 'active-link' : ''}
                  >Portfolio</Link> */}
                  {/* <Link  className={isActivePath('/portfolio') ? 'active-link' : ''} to=''>Portfolio</Link> */}
                  <Link className={isPortfolioActive ? 'active-link' : ''} to="/portfolio">Portfolio</Link>
                  {activeMegaMenu === 'portfolio' && (
                    <div className={`mega-menu ${isMenuOpen ? 'open' : 'closed'}`} id="portfolio-mega-menu">
                      <ul>
                        <li>
                          <div className="newmega">
                            {/* <Link
                              to=""
                              ref={(el) => linkRefs.current['Mobile-Apps'] = el}
                              className="native-apps portfolioPadding"
                              onClick={() => handleClick('Mobile-Apps', 'Mobile-Apps')}
                              onMouseEnter={() => handleClick('Mobile-Apps', 'Mobile-Apps')}
                            > <Link to="/Mobile-Portfolio">
                                Mobile Apps
                              </Link></Link> */}
                            {/* <Link
                              to="/Mobile-Portfolio"
                              ref={(el) => (linkRefs.current['Mobile-Apps'] = el)}
                              className="native-apps portfolioPadding"
                              onClick={() => handleClick('Mobile-Apps', 'Mobile-Apps')}
                              onMouseEnter={() => handleClick('Mobile-Apps', 'Mobile-Apps')}
                            >
                              Mobile Apps
                            </Link> */}
                            <Link
                              to="/Mobile-Portfolio"
                              ref={(el) => (linkRefs.current['Mobile-Apps'] = el)}
                              className={`Mobile-Apps portfolioPadding ${isMobileAppsActive ? 'active-link' : ''}`}
                              onClick={() => {
                                handleClick('Mobile-Apps', 'Mobile-Apps');
                                setTimeout(() => {
                                  window.location.reload();
                                }, 0);
                              }}
                              onMouseEnter={() => handleClick('Mobile-Apps', 'Mobile-Apps')}
                            >
                              Mobile Apps
                            </Link>

                          </div>
                          <ul className="submenu open" id="portfolio">
                            <div className="row">
                              <div className="col-md-4"></div>
                              <div className="col-md-4">
                                {/* <Link to="/Mobile-Portfolio">
                                  <img src={mobile} alt="" />
                                </Link> */}
                                <Link
                                  to="/Mobile-Portfolio"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                >
                                  <img src={mobile} alt="" />
                                </Link>

                              </div>
                              <div className="col-md-4"></div>
                            </div>
                          </ul>
                        </li>
                        <li>
                          <div className="newmega">
                            {/* <Link
                              to="#"
                              ref={(el) => linkRefs.current['Website'] = el}
                              className="native-apps portfolioPadding"
                              onClick={() => handleClick('Website', 'Website')}
                              onMouseEnter={() => handleClick('Website', 'Website')}
                            > <Link to='/web-portfolio'>Website
                              </Link></Link> */}
                            {/* <Link
                              to="/web-portfolio"
                              ref={(el) => (linkRefs.current['Website'] = el)}
                              className="native-apps portfolioPadding"
                              onClick={() => handleClick('Website', 'Website')}
                              onMouseEnter={() => handleClick('Website', 'Website')}
                            >
                              Website
                            </Link> */}
                            <Link
                              to="/web-portfolio"
                              ref={(el) => (linkRefs.current['Website'] = el)}
                              className={`Website portfolioPadding ${isWebsiteportfolioActive ? 'active-link' : ''}`}
                              onClick={() => {
                                handleClick('Website', 'Website');
                                setTimeout(() => {
                                  window.location.reload();
                                }, 0);
                              }}
                              onMouseEnter={() => handleClick('Website', 'Website')}
                            >
                              Website
                            </Link>

                          </div>
                          <ul className="submenu" id="portfolio">
                            <div className="row">
                              <div className="col-md-4"></div>
                              <div className="col-md-4">
                                {/* <Link to='/web-portfolio'><img src={web} alt="" />
                                </Link> */}
                                <Link
                                  to="/web-portfolio"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                >
                                  <img src={web} alt="" />
                                </Link>

                              </div>
                              <div className="col-md-4"></div>
                            </div>
                          </ul>
                        </li>
                        <li>
                          <div className="newmega">
                            {/* <Link
                              to="#"
                              ref={(el) => linkRefs.current['Gaming'] = el}
                              className="native-apps portfolioPadding"
                              onClick={() => handleClick('Gaming', 'Gaming')}
                              onMouseEnter={() => handleClick('Gaming', 'Gaming')}
                            > <Link to='/game-portfolio'>Gaming
                              </Link></Link> */}
                            {/* <Link
                              to="/game-portfolio"
                              ref={(el) => (linkRefs.current['Gaming'] = el)}
                              className="native-apps portfolioPadding"
                              onClick={() => handleClick('Gaming', 'Gaming')}
                              onMouseEnter={() => handleClick('Gaming', 'Gaming')}
                            >
                              Gaming
                            </Link> */}
                            <Link
                              to="/game-portfolio"
                              ref={(el) => (linkRefs.current['Gaming'] = el)}
                              className={`Gaming portfolioPadding ${isGamingportfolioActive ? 'active-link' : ''}`}
                              onClick={() => {
                                handleClick('Gaming', 'Gaming');
                                setTimeout(() => {
                                  window.location.reload();
                                }, 0);
                              }}
                              onMouseEnter={() => handleClick('Gaming', 'Gaming')}
                            >
                              Gaming
                            </Link>


                          </div>
                          <ul className="submenu" id="portfolio">
                            <div className="row">
                              <div className="col-md-4"></div>
                              <div className="col-md-4">
                                {/* <Link to='/game-portfolio'><img src={screen} alt="" />
                                </Link> */}
                                <Link
                                  to="/game-portfolio"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                >
                                  <img src={screen} alt="" />
                                </Link>

                              </div>
                              <div className="col-md-4"></div>
                            </div>
                          </ul>
                        </li>
                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['Our-Products'] = el}
                              className={`Our-Products ${isOurproductsActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('Our-Products', 'Our-Products')}
                              onMouseEnter={() => handleClick('Our-Products', 'Our-Products')}
                            >Our Products</Link>

                          </div>
                          <ul className="submenu myportfolioimg" id="portfolio">
                            <div className="row">
                              <div className="col-md-6 myportcol">
                                <a href="https://invoicemint.in/"> <img className="myportcolimgone" src={invoicemint} alt="" /></a>
                              </div>
                              <div className="col-md-6 myportcol">
                                <a href="https://spliter.interestbudsolutions.com/"><img className="myportcolimgtow" src={spliimg} alt="" /></a>
                              </div>
                            </div>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  )}
                </li>
                <li
                  onMouseEnter={() => handleMouseEnter('service')}
                  onMouseLeave={handleMouseLeave}
                >
                  {/* <Link className={isActivePath('/services') ? 'active-link' : ''} to=''>Services</Link> */}

                  <Link
                    className={
                      isActivePath('/services') ||
                        location.pathname.startsWith('/animation') ||
                        location.pathname.startsWith('/designing') ||
                        location.pathname.startsWith('/web-apps') ||
                        location.pathname.startsWith('/native-apps') ||
                        location.pathname.startsWith('/blockchain') ||
                        location.pathname.startsWith('/gaming-apps') ||
                        location.pathname.startsWith('/cross-platform') ||
                        location.pathname.startsWith('/website-development')
                        ? 'active-link'
                        : ''
                    }
                    to=''
                  >
                    Services
                  </Link>

                  {activeMegaMenu === 'service' && (
                    <div className={`mega-menu ${isMenuOpen ? 'open' : 'closed'}`} id="service">
                      <ul>
                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['native-apps'] = el}
                              className=
                              {`native-apps ${isActivePath('/services/native-apps') || isActivePath('/services/android') || isActivePath('/services/wearable') ? 'active-link' : ''}`}

                              onClick={() => { handleClick('native-apps', 'native-apps') }}
                              onMouseEnter={() => handleClick('native-apps', 'native-apps')}
                              style={{ paddingRight: '20px' }}>
                              Native Apps
                            </Link>
                          </div>
                          <ul className="submenu open">
                            <div className="row">
                              <div className="col-md-6">
                                <h1 id="submenu-h1">Native Apps</h1>
                                <li
                                  onClick={() => { handleMenuClose() }}
                                > <Link
                                  to="/services/native-apps/Mobile-development"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/native-apps/Mobile-development' ? 'active-link' : ''}
                                >
                                    <img src={native1} alt="" />Mobile App Development
                                  </Link>
                                </li>
                                <li> <Link
                                  to="/services/native-apps/ios"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/native-apps/ios' ? 'active-link' : ''}
                                >
                                  <img src={native2} alt="" />Native iOS Apps
                                </Link>
                                </li>
                                <li><Link
                                  to="/services/android"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/android' ? 'active-link' : ''}
                                >
                                  <img src={native3} alt="" />Android App Apps
                                </Link>
                                </li>
                                <li> <Link
                                  to="/services/wearable"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/wearable' ? 'active-link' : ''}
                                >
                                  <img src={native4} alt="" />Wearable App Development
                                </Link>
                                </li>
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src={Appdevelopment} alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>
                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['cross-platform'] = el}
                              className={`cross-platform ${isCrossplatformActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('cross-platform', 'cross-platform')}
                              onMouseEnter={() => handleClick('cross-platform', 'cross-platform')} style={{ paddingRight: '20px' }}>
                              Cross Platform
                            </Link>
                          </div>
                          <ul className="submenu">
                            <div className="row">
                              <div className="col-md-6">
                                <h1 id="submenu-h1">Cross Platform</h1>
                                <li> <Link
                                  to="/services/native-apps/Mobile-development"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/native-apps/Mobile-development' ? 'active-link' : ''}
                                >
                                  <img src={cpa1} alt="" />Xamarin
                                </Link>
                                </li>
                                <li>  <Link
                                  to="/services/native-apps/Mobile-development"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/native-apps/Mobile-development' ? 'active-link' : ''}
                                >
                                  <img src={cpa2} alt="" />React Native
                                </Link>
                                </li>
                                <li> <Link
                                  to="/services/native-apps/Mobile-development"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/native-apps/Mobile-development' ? 'active-link' : ''}
                                >
                                  <img src={cpa3} alt="" />Flutter App Development
                                </Link>
                                </li>
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src={Mobiledevelopment} alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>

                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['gaming-apps'] = el}
                              className={`gaming-apps ${isGamingActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('gaming-apps', 'gaming-apps')}
                              onMouseEnter={() => handleClick('gaming-apps', 'gaming-apps')}
                              style={{ paddingRight: '20px' }}>
                              Gaming Apps
                            </Link>

                          </div>
                          <ul className="submenu">
                            <div className="row">
                              <div className="col-md-6">
                                <h1 id="submenu-h1">Gaming Apps</h1>
                                <li> <Link
                                  to="/services/unity-gaming"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/unity-gaming' ? 'active-link' : ''}
                                >
                                  <img src={gaming1} alt="" />Unity Engines
                                </Link>
                                </li>
                                <li><Link
                                  to="/services/unity-gaming"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/unity-gaming' ? 'active-link' : ''}
                                >
                                  <img src={gaming2} alt="" />2D/3D Games
                                </Link>
                                </li>
                                <li> <Link
                                  to="/services/unity-gaming"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/unity-gaming' ? 'active-link' : ''}
                                >
                                  <img src={gaming3} alt="" />AR/VR Games
                                </Link>
                                </li>
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src={Gameanalytics} alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>

                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['web-apps'] = el}
                              className={`web-apps ${isWebappsActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('web-apps', 'web-apps')}
                              onMouseEnter={() => handleClick('web-apps', 'web-apps')}
                              style={{ paddingRight: '20px' }}>
                              Web Apps
                            </Link>

                          </div>
                          <ul className="submenu">
                            <div className="row">
                              <div className="col-md-6">
                                <h1 id="submenu-h1">Web Apps</h1>
                                <li><Link
                                  to="/services/website"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/website' ? 'active-link' : ''}
                                >
                                  <img src={webapp1} alt="" />Angular
                                </Link>
                                </li>
                                <li><Link
                                  to="/services/website"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/website' ? 'active-link' : ''}
                                >
                                  <img src={webapp2} alt="" />React JS
                                </Link>

                                </li>
                                <li><Link
                                  to="/services/website"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/website' ? 'active-link' : ''}
                                >
                                  <img src={webapp3} alt="" />PHP
                                </Link>
                                </li>
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src={Mobilebrowsers} alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>

                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['website-development'] = el}
                              className={`website-development ${isWebsiteActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('website-development', 'website-development')}
                              onMouseEnter={() => handleClick('website-development', 'website-development')}
                              style={{ paddingRight: '20px' }}>
                              Website Development
                            </Link>

                          </div>
                          <ul className="submenu">
                            <div className="row">
                              <div className="col-md-6">
                                <h1 id="submenu-h1">Website Apps</h1>
                                <li><Link
                                  to="/services/website"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/website' ? 'active-link' : ''}
                                >
                                  <img src={webdevelopement1} alt="" />PHP
                                </Link>
                                </li>
                                <li><Link
                                  to="/services/website"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/website' ? 'active-link' : ''}
                                >
                                  <img src={webdevelopement2} alt="" />Code Ignitor
                                </Link>
                                </li>
                                <li><Link
                                  to="/services/website"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/website' ? 'active-link' : ''}
                                >
                                  <img src={webdevelopement3} alt="" />Laravel
                                </Link>

                                </li>
                                <li><Link
                                  to="/services/website"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/website' ? 'active-link' : ''}
                                >
                                  <img src={webdevelopement4} alt="" />Cake PHP
                                </Link>

                                </li>
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src={Websitedesigner} alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>

                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['designing'] = el}
                              className={`designing ${isDesigningActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('designing', 'designing')}
                              onMouseEnter={() => handleClick('designing', 'designing')}
                              style={{ paddingRight: '20px' }}>
                              Designing
                            </Link>

                          </div>
                          <ul className="submenu">
                            <div className="row">
                              <div className="col-md-6">
                                <h1 id="submenu-h1">Designing</h1>
                                <li><Link
                                  to="/services/designing"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/designing' ? 'active-link' : ''}
                                >
                                  <img src={designing1} alt="" />UI/UX
                                </Link>

                                </li>
                                <li><Link
                                  to="/services/designing"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/designing' ? 'active-link' : ''}
                                >
                                  <img src={designing2} alt="" />Logo Design
                                </Link>

                                </li>
                                <li><Link
                                  to="/services/designing"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/services/designing' ? 'active-link' : ''}
                                >
                                  <img src={designing3} alt="" />Graphic Design
                                </Link>

                                </li>
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src={Graphicdesign} alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>

                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['blockchain-token'] = el}
                              className={`blockchain-token ${isBlockchainActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('blockchain-token', 'blockchain-token')}
                              onMouseEnter={() => handleClick('blockchain-token', 'blockchain-token')}
                              style={{ paddingRight: '20px' }}>
                              Blockchain And Token
                            </Link>
                          </div>
                          <ul className="submenu">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="blockchain-btns">
                                  <button
                                    onClick={() => handleSectionChange('blockchain-development')}
                                    className={activeSection === 'blockchain-development' ? 'active' : ''}
                                  >
                                    Blockchain Development
                                  </button>
                                  <button
                                    onClick={() => handleSectionChange('token-development')}
                                    className={activeSection === 'token-development' ? 'active' : ''}
                                  >
                                    Token Development
                                  </button>
                                  <button
                                    onClick={() => handleSectionChange('other-development')}
                                    className={activeSection === 'other-development' ? 'active' : ''}
                                  >
                                    Other Development
                                  </button>
                                </div>

                                {activeSection === 'blockchain-development' && (
                                  <div className="blockchain-development">
                                    <li><Link
                                      to="/services/blockchain-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/services/blockchain-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain1} alt="" />Blockchain Development
                                    </Link>

                                    </li>
                                    <li><Link
                                      to="/services/ALT-coin-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/services/ALT-coin-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Alt Coin Development Service
                                    </Link>

                                    </li>
                                    <li><Link
                                      to="/services/multichain-blockchain-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/services/multichain-blockchain-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Multichain Blockchain
                                    </Link>

                                    </li>
                                    <li><Link
                                      to="/services/crypto-mlm-software-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/services/crypto-mlm-software-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Crypto MLM Software Development
                                    </Link>

                                    </li>
                                    <li><Link
                                      to="/services/smart-contract-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/services/smart-contract-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Smart Contract Development
                                    </Link>

                                    </li>
                                    <li><Link
                                      to="/services/crypto-wallet-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/services/crypto-wallet-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Crypto Wallet Development
                                    </Link>

                                    </li>
                                    <li><Link
                                      to="/services/crypto-currency-exchange-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/services/crypto-currency-exchange-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Crypto Exchange Services
                                    </Link>

                                    </li>
                                  </div>
                                )}

                                {activeSection === 'token-development' && (
                                  <div className="token-development">
                                    <li><Link
                                      to="/Crypto-Token-Development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/Crypto-Token-Development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain1} alt="" />Crypto Token Development
                                    </Link>


                                    </li>
                                    <li><Link
                                      to="/ERCToken"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/ERCToken' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />ERC-20 Token Development
                                    </Link>


                                    </li>
                                    <li><Link
                                      to="/EthereumTokenDevelopment"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/EthereumTokenDevelopment' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Ethereum Token Development
                                    </Link>


                                    </li>
                                    <li><Link
                                      to="/solana-token"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/solana-token' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Solana Token Development
                                    </Link>


                                    </li>
                                    <li><Link
                                      to="/tron-token"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/tron-token' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain2} alt="" />Tron Token Development
                                    </Link>

                                    </li>
                                  </div>
                                )}

                                {activeSection === 'other-development' && (
                                  <div className="other-development">
                                    <li><Link
                                      to="/white-paper"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/white-paper' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain3} alt="" />Crypto White Paper Development
                                    </Link>

                                    </li>
                                    <li><Link
                                      to="/polygon-development"
                                      onClick={() => {
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 0);
                                      }}
                                      className={location.pathname === '/polygon-development' ? 'active-link' : ''}
                                    >
                                      <img src={blockchain3} alt="" />Polygon Blockchain Development
                                    </Link>

                                    </li>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src={BitcoinP2P} alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>
                        {/* animation .. . . */}

                        <li>
                          <div className="newmega">
                            <Link
                              to=""
                              ref={(el) => linkRefs.current['animation'] = el}
                              className={`animation ${isAnimationActive ? 'active-link' : ''}`}
                              onClick={() => handleClick('animation', 'animation')}
                              onMouseEnter={() => handleClick('animation', 'animation')}
                              style={{ paddingRight: '20px' }}>
                              Animation Design
                            </Link>

                          </div>
                          <ul className="submenu subtow">
                            <div className="row">
                              <div className="col-md-6" >
                                <h1 id="submenu-h1">Animation Design</h1>
                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animaa} alt="" />Animated Explainer Videos
                                </Link>

                                </li>

                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animab} alt="" />Learning videos designed
                                </Link>

                                </li>
                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animac} alt="" />Engaging SaaS videos
                                </Link>

                                </li>
                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animad} alt="" />Dynamic Social Media Videos
                                </Link>

                                </li>
                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animae} alt="" />Whiteboard Videos
                                </Link>

                                </li>
                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animaf} alt="" />B-roll Explainer Videos
                                </Link>

                                </li>
                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animag} alt="" />Promotional videos
                                </Link>

                                </li>
                                <li><Link
                                  to="/animation"
                                  onClick={() => {
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 0);
                                  }}
                                  className={location.pathname === '/animation' ? 'active-link' : ''}
                                >
                                  <img src={animah} alt="" />Animated infographics videos
                                </Link>

                                </li>
                              </div>
                              <div className="col-md-1">
                                <div className='bfhgd'></div>
                              </div>
                              <div className="col-md-5">
                                <img src="https://www.interestbudsolutions.com/wp-content/uploads/2023/11/Graphic-design-1.gif" alt="" />
                              </div>
                            </div>
                          </ul>
                        </li>

                      </ul>
                    </div>
                  )}
                </li>


                <li className="connect-btns"><Link
                  to="/contact"
                  onClick={() => {
                    setTimeout(() => {
                      window.location.reload();
                    }, 0);
                  }}
                  className={location.pathname === '/contact' ? 'active-link' : ''}
                >
                  Contact Us
                </Link>

                </li>
                <div className="listimg">
                  <li><Link to="https://wa.me"><img src={whatsapp} alt="WhatsApp" /></Link></li>
                  <div className="sep"></div>
                  <li className="dropdowns">
                    <img src={phncall} alt="Phone Call" />
                    <div className="dropdowns-contents">
                      <h3>Write To Us</h3>
                      <b style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        fontFamily: 'poppins'
                      }}>support@interestbudsolutions.com</b>
                      <h3>We are just a call away</h3>
                      <p>+91 8076569119 (Sales)<br />+91 9001761400 (HR)</p>
                    </div>
                  </li>
                </div>
              </ul>
            </nav>
            <div className="hamburger" id="hamburger" onClick={toggleNav}>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </header>
        </div>
      </div>
      {/* mobileresponshive header ... .. */}
      <MobileHeader />
      {/* <div class="IBSpreLoader">
        <svg
          className="loading-spinner"
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
          ref={svgRef}
        >
          <path
            id="loopingPath"
            d="M25.8,13.5l-12,13.9c-2.1,2.5-.4,6.3,2.9,6.3h6.2c3.3,0,5-3.8,2.9-6.3l-12-13.9c-2.1-2.5-.4-6.3,2.9-6.3h6.2c3.3,0,5,3.8,2.9,6.3Z"
            fill="none"
          />
          <g id="circles" ref={circlesGroupRef}></g>
        </svg>
      </div> */}

    
    </div>




  );
};

export default Header;
